'use client'
import Link from 'next/link'
import styles from './style.module.scss'

type Props = {
  fixedHeader: boolean
}

export const SiteLogo = ({ fixedHeader }: Props) => {
  return (
    <Link
      href="/"
      className={
        styles.siteLogo + ' ' + (fixedHeader ? styles.siteLogoFixed : '')
      }
      aria-label="ななろぐ"
    ></Link>
  )
}

export default SiteLogo
